import { AbstractReportPmsApiService } from '../abstract-report.service';
import { DetailedTaxesFeesReport } from '../../../models/reports/financial/detailed-taxes-fees-report.model';
import {PaginationCollection} from "../../../models";

/**
 * @class DetailedTaxesFeesReportPmsApiService
 * @extends {AbstractReportPmsApiService<DetailedTaxesFeesReport>}
 */
export class DetailedTaxesFeesReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/financial/detailed-tax-fee';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {DetailedTaxesFeesReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new DetailedTaxesFeesReport(attributes);
    }



    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Object.<string, *>} paginationData
     * @param {...*} params
     * @returns {PaginationCollection<M>}
     * @protected
     */
    newPaginationCollection(paginationData, ...params) {

        return new PaginationCollection({
            perPage: paginationData.per_page,
            page: paginationData.current_page,
            total: paginationData.total,
            from: paginationData.from,
            to: paginationData.to,
            models: paginationData.data.map(
                (attributes) => this.newModel(attributes, ...params)),
            total_row: paginationData.total_row,
        });
    }

    /**
     * @param {Object} params
     * @param {Property} property
     * @returns {Promise<Reservation[]>}
     */
    reservationsWithoutInvoice(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/reservations-without-invoices';

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reports/financial/detailed-taxes-fees-report.service.js